import { useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import Request from "../based/Request";

function UploadInvoiceModal({ show, onClose, originalInvoiceId, onSucceed }) {
    const [invoiceNo, setInvoiceNo] = useState("");

    return (
        <CommonModal show={show} onClose={onClose} title="Upload hóa đơn" hideOnClose>
            <Wrapper>
                <div className="upload-area my-1">
                    <label htmlFor="upload-invoice-file">Chọn file hóa đơn</label>
                    <div className="input-upload">
                        <input id="upload-invoice-file" type="file" name="" />
                    </div>
                </div>
                <div className="upload-area my-1">
                    <label htmlFor="upload-invoice-number">Số hóa đơn</label>
                    <div className="input-upload">
                        <input id="upload-invoice-number" type="text" name="" value={invoiceNo} onChange={(e) => setInvoiceNo(e.target.value)} />
                    </div>
                </div>
                <div className="confirm_release_bottom">
                    <div className="lst-button">
                        <button
                            className="btn btn-danger"
                            onClick={(e) => {
                                onClose();
                            }}
                        >
                            Đóng
                        </button>
                        <button
                            className="btn btn-custom"
                            onClick={(e) => {
                                //let input
                                let input = document.getElementById("upload-invoice-file");
                                const file = input.files[0];
                                Request.UploadInvoice(file, originalInvoiceId, invoiceNo).then((res) => {
                                    onSucceed();
                                });
                            }}
                        >
                            Xác nhận đã xuất
                        </button>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default UploadInvoiceModal;

const Wrapper = styled.div`
    input#upload-invoice-number {
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .confirm_release_bottom {
        margin-top: 62px;
    }

    .confirm_release_address-line {
        display: flex;
        align-items: center;
        margin: 2px 0px;
    }

    .confirm_release_address-line .left-line {
        color: #666f7b;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        width: 100px;
    }

    .confirm_release_address-line .right-line {
        flex: 1;
    }

    .confirm_release_total-line {
        display: flex;
        align-items: center;
        margin: 2px 0;
    }

    .confirm_release_total {
        margin: 8px 0;
    }

    .confirm_release_total-line .left-line {
        color: #666f7b;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .confirm_release_total-line .right-line {
        margin-left: auto;
    }

    .lst-button {
        display: flex;
        justify-content: space-around;
    }

    .lst-button button {
        width: 45%;
    }
`;
